module.exports = __webpack_public_path__ + "static/media/calendar.e6ae84e4.svg";